import { ApiBase } from '@/libs/apis/base';

export class FrontendApiBase extends ApiBase {
  constructor(vue) {
    super(vue, 'frontend', false);
    this.errorName = 'FrontendApiError';
  }
}
